export const BODY = 'body';
export const CONTENT = 'content';
export const BODY_CONTENT = 'body_content';

export const HEADER = 'header';
export const HEADER_1 = 'header-1';
export const HEADER_2 = 'header-2';
export const HEADER_3 = 'header-3';

export const FULL_WIDTH = 'full-width';
export const FULL_WIDTH_1 = 'full-width-1';
export const FULL_WIDTH_2 = 'full-width-2';
export const FULL_WIDTH_3 = 'full-width-3';
export const FULL_WIDTH_4 = 'full-width-4';
export const FULL_WIDTH_5 = 'full-width-5';

export const LEFT_RIGHT_MEDIA = 'left-right-media';
export const LEFT_RIGHT_MEDIA_1 = 'left-right-media-1';
export const LEFT_RIGHT_MEDIA_2 = 'left-right-media-2';

export const TWO_COLUMNS = 'two-columns';
export const TWO_COLUMNS_1 = 'two-columns-1';
export const TWO_COLUMNS_2 = 'two-columns-2';
export const TWO_COLUMNS_3 = 'two-columns-3';

export const PROPOSAL_SUMMARY = 'proposal-summary';

export const THREE_COLUMNS = 'three-columns';
export const THREE_COLUMNS_1 = 'three-columns-1';
export const THREE_COLUMNS_2 = 'three-columns-2';
export const THREE_COLUMNS_3 = 'three-columns-3';

export const GALLERY = 'gallery';
export const GALLERY_1 = 'gallery-1';

export const FOOTER = 'footer';
export const FOOTER_1 = 'footer-1';

export const MAX_SECTIONS = 30;
